import {
  type DashRouteType,
  URL_PARTNER_SCOPED,
  URL_SITE_SCOPED,
} from '@retailer-platform/dashboard/routing'

// Warehouse-less, site-scoped parent route: partner + site only
// (`/partners/:partner_id/cart-assistant/sites/:storeConfigId`). It builds off URL_PARTNER_SCOPED (not
// URL_RETAILER_SCOPED), deliberately dropping the `/warehouses/:warehouse_id` segment — the editor keys
// everything on `storeConfigId` (site) and nothing downstream reads a warehouse. This is the same
// warehouse-less pattern the storefront domain uses for its Storefront Pro content pages, and it is why
// `cartAssistantRouter` is registered in the domain's `partnerScoped` router bucket (not `scoped`).
//
// The parent <Route> puts `storeConfigId` into the React Router match that descendants read via
// useParams(). DashRoute renders a route's <RetailerScopeWrapper> *above* that route's own <Route> (see
// dash-route/DashRoute.tsx), so the scope wrapper only sees params from an ancestor route — it cannot
// see its own `:storeConfigId`. Nesting the editor under this site-scoped parent is what lets the
// STORE_CONFIG picker resolve the store config instead of throwing on an undefined param.
const URL_CART_ASSISTANT = `${URL_PARTNER_SCOPED}/cart-assistant${URL_SITE_SCOPED}`
// The `/editor` URL is the Cart Assistant configuration landing page (display name, badge, greeting,
// disclaimer, support / learn-more URLs, tone). The cold-start prompt-starters editor is an extended
// child route beneath it, so the two share the site-scoped parent and the single nav entry.
const URL_CART_ASSISTANT_EDITOR = `${URL_CART_ASSISTANT}/editor`
const URL_CART_ASSISTANT_COLD_START_PROMPTS = `${URL_CART_ASSISTANT_EDITOR}/cold-start-prompts`
// @hygen:inject scoped-urls

export type DashRouteSet = DashRouteType<
  'cart-assistant' | 'cart-assistant-editor' | 'cart-assistant-cold-start-prompts'
>
// @hygen:inject dash-route-set

export const routes: { [Key in DashRouteSet['identifier']]: string } = {
  'cart-assistant': URL_CART_ASSISTANT,
  'cart-assistant-editor': URL_CART_ASSISTANT_EDITOR,
  'cart-assistant-cold-start-prompts': URL_CART_ASSISTANT_COLD_START_PROMPTS,
  // @hygen:inject route-pair
}

export type DomainRouteName = keyof typeof routes
